<template>
  <g>
    <defs>
      <path
        id="trailer@1x-a"
        d="M20.704,5.168H3.296c-.824,0-1.495.671-1.495,1.495v6.933c0,.824.671,1.495,1.495,1.495h1.008v.418c0,.283.23.513.513.513h.733v1.202c0,.283.23.513.513.513s.513-.23.513-.513v-1.202h.733c.283,0,.513-.23.513-.513v-.418h1.773l2.433,2.409c.096.095.226.148.361.148h.962c.218.686.861,1.184,1.618,1.184s1.4-.498,1.618-1.184h.456c.218.686.861,1.184,1.618,1.184s1.4-.498,1.618-1.184h.967c.283,0,.513-.23.513-.513v-2.481c.272-.271.441-.645.441-1.059v-6.933c0-.824-.671-1.495-1.495-1.495h0ZM3.296,14.064c-.259,0-.469-.21-.469-.469v-6.933c0-.259.21-.469.469-.469h17.409c.259,0,.469.21.469.469v6.933c0,.259-.21.469-.469.469H3.296ZM14.536,17.648c-.146-.123-.239-.307-.239-.513s.093-.39.239-.513c.117-.099.268-.159.433-.159s.316.06.433.159c.146.123.239.307.239.513s-.093.39-.239.513c-.117.099-.268.159-.433.159s-.316-.06-.433-.159ZM18.228,17.648c-.146-.123-.239-.307-.239-.513s.093-.39.239-.513c.117-.099.268-.159.433-.159s.316.06.433.159c.146.123.239.307.239.513s-.093.39-.239.513c-.117.099-.268.159-.433.159s-.316-.06-.433-.159ZM20.733,15.09v1.532h-.454c-.218-.686-.861-1.184-1.618-1.184s-1.4.498-1.618,1.184h-.456c-.218-.686-.861-1.184-1.618-1.184s-1.4.498-1.618,1.184h-.751l-1.547-1.532h9.681,0Z M5.986,12.682c.283,0,.513-.23.513-.513v-4.08c0-.283-.23-.513-.513-.513s-.513.23-.513.513v4.08c0,.283.23.513.513.513Z M9.984,12.682c.283,0,.513-.23.513-.513v-4.08c0-.283-.23-.513-.513-.513s-.513.23-.513.513v4.08c0,.283.23.513.513.513Z M13.981,12.682c.283,0,.513-.23.513-.513v-4.08c0-.283-.23-.513-.513-.513s-.513.23-.513.513v4.08c0,.283.23.513.513.513Z M17.978,12.682c.283,0,.513-.23.513-.513v-4.08c0-.283-.23-.513-.513-.513s-.513.23-.513.513v4.08c0,.283.23.513.513.513Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" xlink:href="#trailer@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>